
import React from 'react';

import './styles.scss';

import {Event} from '@material-ui/icons';
import {DatePicker, MuiPickersUtilsProvider} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';

import datePickerCtor from '../../utils/datePickerCtor';

import LabelDisplay from '../LabelDisplay';
import HelperText from '../HelperText';
import {Ripple} from "../../../Buttons";

const Input = ({
  id,
  name,
  onChange,
  format,
  views,
  disableFuture,
  minDate,
  maxDate,
  value,
  disabled
}) => (
  <MuiPickersUtilsProvider
    utils={DateFnsUtils}
  >
    <DatePicker
      id={`${id}Input`}
      margin="none"
      variant="dialog"
      inputVariant="outlined"
      format={format}
      views={views}
      value={value || null}
      disabled={disabled}
      disableFuture={disableFuture}
      minDate={minDate}
      maxDate={maxDate}
      onChange={(value) => {
        // onChange(name, formatDate(value, 'yyyy-MM-dd'))
        onChange(name, value)
      }}
      error={false}
    />
    <div className="merchant-datepicker__icon">
      <Ripple
        onClick={() => {
          document.getElementById(`${id}Input`).click();
        }}
      >
        <Event />
      </Ripple>
    </div>
  </MuiPickersUtilsProvider>
);

const Component = ({
 className,
 labelProps,
 inputProps,
 errorProps
}) => {
  return (
    <div
      id={inputProps.id}
      className={[
        'merchant-field',
        'merchant-datepicker',
        inputProps.disabled ? ' disabled' : '',
        errorProps.showError ? ' error' : '',
        className
      ].join(' ')}
    >
      <LabelDisplay {...labelProps} />
      <Input {...inputProps} />
      <HelperText {...errorProps} />
    </div>
  )
}

export default datePickerCtor(Component);

